import React, { memo } from "react";
import Text from "../../../styleguide/Text";
import useTableCtx from "../tableContext/useTableCtx";
import {
  TableSectionActionsProps,
  TableSectionData,
} from "./sectionTable.interface";

function SectionTableTitle({
  section,
  depth = 0,
  isRoot = false,
  SectionActionsComponent,
}: {
  section: TableSectionData;
  depth?: number;
  isRoot?: boolean;
  SectionActionsComponent?: React.ComponentType<TableSectionActionsProps>;
}) {
  const tableContext = useTableCtx()!;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <Text
        component={isRoot ? "h3" : "div"}
        variant="body1"
        className={
          isRoot
            ? "!text-lg font-semibold text-slate-900"
            : "font-semibold text-slate-800"
        }
        style={{ paddingLeft: Math.min(depth, 6) * 16 }}>
        {section.title}
      </Text>
      {SectionActionsComponent && (
        <div className="flex flex-wrap items-center gap-3">
          <SectionActionsComponent
            sectionId={section.id}
            crudData={section.crudData}
            section={section}
            tableContext={tableContext}
          />
        </div>
      )}
    </div>
  );
}

export default memo(SectionTableTitle);
